import React, { lazy, Suspense } from 'react';

import WidgetLoading from 'common/components/widget/WidgetLoading';

const LoadableComponent = lazy(() => import('./CollectionWidget'));

const CollectionWidgetRoot = (props) => (
  <Suspense fallback={<WidgetLoading />}>
    {/* eslint-disable-next-line */}
    <LoadableComponent {...props} />
  </Suspense>
);

export default CollectionWidgetRoot;
